import { CommonModule } from '@angular/common';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { DatiqMenuComponent } from './components/datiq-menu/datiq-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { DatiqButtonModule } from '@dat/datiq-components-pkg/button';
import { DatiqTooltipModule } from '@dat/datiq-components-pkg/tooltip';

const components = [DatiqMenuComponent];

@NgModule({
    declarations: [...components],
    exports: [...components],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        DatiqIconsModule,
        DatiqTooltipModule,
        DatiqButtonModule,
    ],
})
export class DatiqMenuModule {}
